import { SseEventBase } from './sse-event-base.model';
import { SseEventType } from './sse-event-type.model';
import { runInInjectionContext } from '@angular/core';
import { NotificationReasonEnum } from '../../enums/notification/notification-reason.enum';
import { MessageDesignBUtils } from '../../content/components/message-design-b/message-design-b.utils';
import { calcDefaultTimeoutOf, RequestClientService } from '../../services/client/request-client.service';

export class SseInvoicePositionEvent extends SseEventBase {

  type: SseEventType = 'invoicePosition';
  onMessage = (event: MessageEvent<any>): void => {
    const resp = JSON.parse(event.data);

    if (this.hasEvents(resp)) {
      runInInjectionContext(this.injector, () => {
        resp.events.forEach(event => this.onEvent(resp, event));
      });
    }
  }

  private onEvent(resp: any, event: NotificationReasonEnum): void {
    this.ngZone.run(() => {
      switch (event) {
        case NotificationReasonEnum.INVOICE_POSITION_EXTRACTION_WITH_AI_SUCCESS: {
          const start = this.inProgressMessageService.timestamp(resp.demandId);
          setTimeout(() => {
            this.inProgressMessageService.removeMessage(resp.demandId);
            this.on.inProgressAsyncWorkFinished$.next(MessageDesignBUtils.createInvoiceExtractionSuccess());
          }, calcDefaultTimeoutOf(new Date(start)));
          this.on.moduleClassAllocationFinished$.next(resp.bulkIds);
          this.on.aiObjectInvoiceTrigger$.next(resp.objectIds);
          break;
        }

        case NotificationReasonEnum.INVOICE_POSITION_EXTRACTION_WITH_AI_FAILED: {
          const start = this.inProgressMessageService.timestamp(resp.demandId);
          setTimeout(() => {
            this.inProgressMessageService.removeMessage(resp.demandId);
            this.on.inProgressAsyncWorkFinished$.next(MessageDesignBUtils.createInvoiceExtractionFailure());
          }, calcDefaultTimeoutOf(new Date(start)));
          this.on.moduleClassAllocationFinished$.next(resp.bulkIds);
          break;
        }
      }
    });
  }
}
